<template>
    <div>
        <top></top>
        <banners></banners>
        <mxzc></mxzc>
        <mxfw></mxfw>
        <mxsyssb></mxsyssb>
        <bottom></bottom>
    </div>
  
</template>

<script>
import top from './top.vue';
import banners from './banner.vue'
import mxzc from './mxzc.vue'
import mxfw from './mxfw'
import mxsyssb from './mxsyssb'
import bottom from './bottom'
export default {
  components:{
      top,
      banners,
      mxzc,
      mxfw,
      mxsyssb,
      bottom
  }
}
</script>

<style lang="less" scoped>

</style>



// WEBPACK FOOTER //
// src/components/Statistics/statistics.vue